<template>
  <Button v-bind="getBindValue" :class="getButtonClass" @click="onClick">
    <template #icon> <slot name="icon"></slot> </template>
    <template #default="data">
      <TpIcon :name="preIcon" v-if="preIcon" :size="iconSize" />
      <slot v-bind="data || {}"></slot>
      <TpIcon :name="postIcon" v-if="postIcon" :size="iconSize" />
    </template>
  </Button>
</template>

<script lang="ts" setup>
import { Button } from 'ant-design-vue'
import { ComponentOptionsMixin, computed, unref } from 'vue'
import { TpIcon } from '@tni-plus/components/icon'
import { useAttrs } from '@tni-plus/hooks'

import { buttonProps } from './button'

defineOptions({
  name: 'TpButton',
  extends: Button as ComponentOptionsMixin,
  inheritAttrs: false,
})

const props = defineProps(buttonProps)

const attrs = useAttrs({ excludeDefaultKeys: false })
const getButtonClass = computed(() => {
  const { color, disabled } = props
  return [
    {
      [`ant-btn-${color}`]: !!color,
      [`is-disabled`]: disabled,
    },
  ]
})

const getBindValue = computed(() => ({ ...unref(attrs), ...props }))
</script>
